/**
 * Serializes a value to a string format that Datadog can properly display in logs.
 * Datadog may not display null, undefined, or complex objects directly in log context.
 * 
 * @param {*} value - The value to serialize
 * @returns {string} Serialized string representation of the value
 */
export const serializeForDatadog = (value) => {
  if (value === null) {
    return 'null';
  }
  
  if (value === undefined) {
    return 'undefined';
  }
  
  // Handle arrays and objects
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (error) {
      // Handle circular references or other JSON.stringify errors
      return `[Object - Unable to serialize: ${error.message}]`;
    }
  }
  
  // Convert other types to string
  return String(value);
};
